module.exports = __webpack_public_path__ + "img/margaret-brent.f44eedda.png";